/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumTipoDomandaDTOModalitaRiepilogo =
  (typeof EnumTipoDomandaDTOModalitaRiepilogo)[keyof typeof EnumTipoDomandaDTOModalitaRiepilogo];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumTipoDomandaDTOModalitaRiepilogo = {
  STANDARD: 'STANDARD',
  ESTESO: 'ESTESO',
} as const;
